import React, {useContext} from "react";
import OptionIcon from "../../assets/images/options-black.svg";
import FloContext from "../contexts/floContext";

export default function FileOptions(props: any) {
   const {folder, file} = props;
   const {onEnableFileEdit, onFileDelete}: any = useContext(FloContext);
   return(
       <div className="options-sec">
          <div className="options-icon flex">
             <div className="icon">
                <img src={OptionIcon} alt=""/>
             </div>
          </div>
          <ul className="options-list">
             <li className="" onClick={() => onEnableFileEdit(folder, file)}>Rename</li>
             <li className="">Share</li>
             <li className="red-color" onClick={() => onFileDelete(folder, file)}>Delete</li>
          </ul>
       </div>
   )
}
